import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../api/hooks/useAuth';
import { useToast } from '../../context/ToastContext';
import './AdminLogin.css';

export default function AdminLogin() {
  const navigate = useNavigate();
  const { login, loading, error, clearError } = useAuth();
  const { showToast } = useToast();
  
  const [formData, setFormData] = useState({
    email: '',
    password: '',
  });
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user types
    if (error) clearError();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      // Remove role from login payload; backend does not allow it
      const result = await login(formData);
      
      // Check if user is admin
      if (result.user.role === 'admin') {
        // Redirect to admin dashboard
        showToast(result.message || 'Login successful!', 'success');
        navigate('/admin/dashboard', { replace: true });
      } else {
        // Not an admin - show error and logout
        clearError();
        showToast('Access denied. Admin credentials required.', 'error');
        // Optionally logout the user
        // logout();
      }
    } catch (err) {
      console.error('Login error:', err);
      showToast(err.message || 'Login failed', 'error');
    }
  };

  return (
    <div className="admin-login-page">
      <div className="admin-login-container">
        <div className="admin-login-card">
          {/* Logo */}
          <div className="admin-login-logo">
            <img
              src="/chilltree-images/chilltree-logo1.png"
              alt="Chilltree Admin"
              style={{ height: '80px', width: 'auto', display: 'block', margin: '0 auto' }}
            />
          </div>

          {/* Title */}
          <h1 className="admin-login-title">Admin Portal</h1>
          <p className="admin-login-subtitle">Sign in to access the admin dashboard</p>

          {/* Error message handled via toast; inline banner removed */}

          {/* Login Form */}
          <form onSubmit={handleSubmit} className="admin-login-form">
            <div className="form-group">
              <label htmlFor="email">Email Address</label>
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="admin@chilltree.com"
                required
                disabled={loading}
                autoComplete="email"
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <div className="password-input-wrapper">
                <input
                  type={showPassword ? 'text' : 'password'}
                  id="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Enter your password"
                  required
                  disabled={loading}
                  autoComplete="current-password"
                />
                <button
                  type="button"
                  className="password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  disabled={loading}
                  aria-label={showPassword ? 'Hide password' : 'Show password'}
                >
                  {showPassword ? '👁️' : '👁️‍🗨️'}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="admin-login-button"
              disabled={loading}
            >
              {loading ? (
                <>
                  <span className="spinner"></span>
                  Signing in...
                </>
              ) : (
                'Sign In'
              )}
            </button>
          </form>

          {/* Back to Store Link */}
          <div className="admin-login-footer">
            <button
              type="button"
              onClick={() => navigate('/')}
              className="back-to-store-link"
            >
              ← Back to Store
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}


